const { SET_SEARCH_RESULT, CLOSE_SEARCH_RESULT } = require("../types");


export const setSearchResult = (result) => async dispatch => {  

  dispatch({
    type: SET_SEARCH_RESULT, 
    payload: result
  })
}

export const closeSearchResult = () => dispatch => { 
  dispatch({
    type: CLOSE_SEARCH_RESULT
  })
};


// export const updateNoti = (a) => async dispatch => {

//   dispatch({
//     type: UPDATE_NOTI,
//     payload: a
//   })
// }
